import bannerImg from './banners/woman-helping-man-gym.jpg';

const leadEmagrecimento = (t) => ({
    id: 'lead-emagrecimento',
    title: t('templates.items.leadEmagrecimento.title'),
    description: t('templates.items.leadEmagrecimento.description'),
    indicatedFor: t('templates.audiences.nutritionists'),
    stepsCount: 1,
    questionsSummary: [
        t('templates.items.leadEmagrecimento.summary.nameAndContact'),
        t('templates.items.leadEmagrecimento.summary.weightHistory'),
        t('templates.items.leadEmagrecimento.summary.previousAttempts'),
        t('templates.items.leadEmagrecimento.summary.commitmentLevel'),
    ],
    banner: `url(${bannerImg}) center / cover no-repeat`,
    formData: {
        title: t('templates.items.leadEmagrecimento.form.title'),
        active: false,
        allow_multiple_answers: false,
        theme: 'light',
        steps: [
            {
                order: 1,
                title: t('templates.items.leadEmagrecimento.form.application.title'),
                description: null,
                header: null,
                submitAction: 'next_step',
                submitButtonText: t('templates.items.leadEmagrecimento.form.application.submit'),
                allowReturn: false,
                submitLink: null,
                questions: [
                    {
                        order: 1,
                        type: 'full_name',
                        label: t('templates.items.leadEmagrecimento.form.application.fullName.label'),
                        description: null,
                        required: true,
                        settings: null,
                    },
                    {
                        order: 2,
                        type: 'email',
                        label: t('templates.items.leadEmagrecimento.form.application.email.label'),
                        description: null,
                        required: true,
                        settings: null,
                    },
                    {
                        order: 3,
                        type: 'phone',
                        label: t('templates.items.leadEmagrecimento.form.application.whatsapp.label'),
                        description: null,
                        required: true,
                        settings: null,
                    },
                    {
                        order: 4,
                        type: 'weight',
                        label: t('templates.items.leadEmagrecimento.form.application.currentWeight.label'),
                        description: null,
                        required: false,
                        settings: null,
                    },
                    {
                        order: 5,
                        type: 'text',
                        label: t('templates.items.leadEmagrecimento.form.application.targetWeight.label'),
                        description: null,
                        required: true,
                        settings: null,
                    },
                    {
                        order: 6,
                        type: 'yes_no_maybe',
                        label: t('templates.items.leadEmagrecimento.form.application.triedBefore.label'),
                        description: null,
                        required: true,
                        settings: null,
                    },
                    {
                        order: 7,
                        type: 'scale',
                        label: t('templates.items.leadEmagrecimento.form.application.readiness.label'),
                        description: null,
                        required: true,
                        settings: {
                            min: 1,
                            max: 5,
                            minLabel: t('templates.items.leadEmagrecimento.form.application.readiness.minLabel'),
                            maxLabel: t('templates.items.leadEmagrecimento.form.application.readiness.maxLabel'),
                            dotConfigs: [
                                { iconKey: 'star' },
                                { iconKey: 'star' },
                                { iconKey: 'star' },
                                { iconKey: 'star' },
                                { iconKey: 'star' },
                            ],
                        },
                    },
                ],
            },
        ],
        actions: [],
    },
});

export default leadEmagrecimento;
